const mutations = {
  reconstructMenu(state, payload) {
    state.menus = [...payload];
  },
};

export default mutations;
